import { render, staticRenderFns } from "./CollectionAutoComplete.vue?vue&type=template&id=afd5684e&scoped=true"
import script from "./CollectionAutoComplete.vue?vue&type=script&lang=js"
export * from "./CollectionAutoComplete.vue?vue&type=script&lang=js"
import style0 from "./CollectionAutoComplete.vue?vue&type=style&index=0&id=afd5684e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd5684e",
  null
  
)

export default component.exports